import { format } from 'date-fns';
import type { OTAUpdate } from '../types';
import { tz } from '../utils/timezone';

interface Props {
  updates: OTAUpdate[];
}

export function OTAUpdatesCard({ updates }: Props) {
  return (
    <div className="hud-card">
      <div className="hud-corner-tl" /><div className="hud-corner-tr" /><div className="hud-corner-bl" /><div className="hud-corner-br" />
      <div className="hud-card-header">
        <div className="flex items-center gap-2.5">
          <svg className="w-4 h-4 text-hud-amber opacity-80" viewBox="0 0 16 16" fill="none">
            <path d="M8 2V10M5 7L8 10L11 7" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3 12H13" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
          </svg>
          <span className="hud-card-title" style={{ color: '#ffaa00', textShadow: '0 0 8px rgba(255,170,0,0.2)' }}>OTA Updates</span>
        </div>
        <span className="hud-card-badge" style={{ background: 'rgba(255,170,0,0.2)', color: '#ffaa00', borderColor: 'rgba(255,170,0,0.4)' }}>7D</span>
      </div>
      <div className="hud-card-body">
        <div className="space-y-0">
          {updates.map((update, idx) => (
            <div
              key={`${update.device}-${update.timestamp.getTime()}-${idx}`}
              className="flex items-center gap-3 py-2.5 border-b border-card-inner last:border-b-0"
            >
              <span
                className="font-mono text-[9px] tracking-wider uppercase flex-shrink-0 px-2 py-0.5"
                style={{
                  borderRadius: '1px',
                  ...(update.event === 'ota_update'
                    ? { background: 'rgba(0,255,136,0.2)', color: '#00ff88', border: '1px solid rgba(0,255,136,0.4)' }
                    : { background: 'rgba(100,120,140,0.15)', color: '#5a7a8a', border: '1px solid #2a3a4a' }
                  ),
                }}
              >
                {update.event === 'ota_update' ? 'Updated' : 'Skipped'}
              </span>
              <div className="flex-1 min-w-0">
                <div className="font-mono text-xs text-hud-white">{update.device}</div>
                <div className="font-mono text-[10px] text-hud-cyan">
                  {update.oldVersion && update.newVersion
                    ? `v${update.oldVersion} → v${update.newVersion}`
                    : update.currentVersion
                    ? `v${update.currentVersion} (current)`
                    : ''}
                </div>
              </div>
              <span className="font-mono text-[10px] text-[#3a5a6a] flex-shrink-0">
                {format(update.timestamp, 'MMM d HH:mm')} {tz}
              </span>
            </div>
          ))}

          {updates.length === 0 && (
            <p className="font-mono text-sm text-[#3a5a6a] text-center py-8">No OTA updates in the last 7 days</p>
          )}
        </div>
      </div>
    </div>
  );
}
